import { render, staticRenderFns } from "./presentationMagytrack.vue?vue&type=template&id=51150600&"
import script from "./presentationMagytrack.vue?vue&type=script&lang=js&"
export * from "./presentationMagytrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports